import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import LoadingSwitch from 'lib/react-router/loading-switch';
import RouteWithSearch from 'lib/react-router/route-with-search';
import ScrollToTop from 'lib/scroll/scroll-to-top';
import { SectionCountConsumer } from 'lib/section-count-context/section-count-context';

import NotFound from 'four-nets/errors/404/not-found';
import BazaarCategoriesHomepage from 'four-nets/bazaar/categories/bazaar-categories-homepage';
import ProductLoader from 'four-nets/bazaar/product/product-loader';
import MyBazaarLoader from 'four-nets/bazaar/my-bazaar/my-bazaar-loader';
import { MyBazaarType } from 'four-nets/bazaar/my-bazaar/my-bazaar-table/query.graphql.types';
import UserBazaarLoader from 'four-nets/bazaar/user-bazaar/user-bazaar-loader';
import ReplyRedirect from './reply-redirect/reply-redirect';

export const tableTypeToPath = (type: MyBazaarType) => {
    switch (type) {
        case MyBazaarType.SELLING:
            return '/market/my_bazaar/';
        case MyBazaarType.WISHLIST:
            return '/shopping/wishlist/';
        case MyBazaarType.SHOPPING:
            return '/shopping/';
    }
};

class BazaarLoader extends React.PureComponent {
    render() {
        return (
            <React.Fragment>
                <SectionCountConsumer>
                    {({ sectionCounts }) => <ScrollToTop k={sectionCounts.SECTION_MARKET} />}
                </SectionCountConsumer>
                <LoadingSwitch>
                    <Redirect from='/bazar/*' to='/market/*' />
                    <Redirect from='/shops/seller/:username' to='/market/seller/:username' exact={true} />
                    <Redirect from='/shops/:categorySlug' to='/market/:categorySlug' exact={true} />
                    <Redirect
                        from='/shops/:categorySlug/:differentiator/:slug'
                        to='/market/:categorySlug/:differentiator/:slug'
                        exact={true}
                    />
                    <Redirect from='/shops' to='/market/?excludeUsed=true' exact={true} />
                    <RouteWithSearch
                        path='/market/my_bazaar'
                        render={(props: any) => <MyBazaarLoader {...props} myBazaarType={MyBazaarType.SELLING} />}
                        exact={true}
                    />
                    <RouteWithSearch
                        path='/shopping/wishlist'
                        render={(props: any) => <MyBazaarLoader {...props} myBazaarType={MyBazaarType.WISHLIST} />}
                        exact={true}
                    />
                    <RouteWithSearch
                        path='/shopping'
                        render={(props: any) => <MyBazaarLoader {...props} myBazaarType={MyBazaarType.SHOPPING} />}
                        exact={true}
                    />
                    <Redirect
                        from='/market/auth/:categorySlug/:differentiator/:slug'
                        to='/market/:categorySlug/:differentiator/:slug'
                        exact={true}
                    />
                    <RouteWithSearch path='/market/seller/:username' component={UserBazaarLoader} exact={true} />
                    <RouteWithSearch path='/market/reply/:token' component={ReplyRedirect} exact={true} />
                    <RouteWithSearch
                        path='/market/:categorySlug/:differentiator/:slug'
                        component={ProductLoader}
                        exact={true}
                    />
                    <RouteWithSearch path='/market/:slug?' component={BazaarCategoriesHomepage} exact={true} />
                    <Route component={NotFound} />
                </LoadingSwitch>
            </React.Fragment>
        );
    }
}

export default BazaarLoader;
